import { render, staticRenderFns } from "./ConnectionSelect.vue?vue&type=template&id=08b36d72&scoped=true"
import script from "./ConnectionSelect.vue?vue&type=script&lang=js"
export * from "./ConnectionSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b36d72",
  null
  
)

export default component.exports